import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as ChildrenCreators } from 'store/ducks/children';
import PageBase from 'components/PageBase';
import PropTypes from 'prop-types';
import ChildrenView from 'components/Pages/ClientPage/ChildrenView';

const ChildrenViewPage = ({ match }) => {
  const dispatch = useDispatch();

  const [localState, setLocalState] = React.useState(null);

  const { children, childrenLoading, childrenListTotal } = useSelector(state => state.children);

  const { params } = match;

  const getInitialData = () => {
    
    dispatch(ChildrenCreators.getChildrenRequest({ id: params.childrenId }));
    setLocalState(null);
  };

  React.useEffect(() => {
    getInitialData();
  }, []);

  React.useEffect(() => {
    if (
      Object.keys(children).length > 0 &&
      !childrenLoading &&
      children.id === Number(params.childrenId)
    ) {
      setLocalState(children);
    }
  }, [children]);

  return (
    <PageBase>{localState && <ChildrenView childrenInfo={localState} clientId={params.clientId} />}</PageBase>
  );
};

ChildrenViewPage.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default ChildrenViewPage;
